import React, { useState } from "react";
import axios from "axios";
import MenuBar from "../UI/Menu/Menu";
import "./Home.css";
import { LuConstruction } from "react-icons/lu";
import {UnderConstructionStyled} from "../../styled/UnderConstruction";
import Button from "../UI/Buttons/Button";
import { useSelector } from "react-redux";
import { useErrorSetter, useSuccessSetter } from '../../hooks/useUiMessages';
import OvalSpinner from "../UI/Spinners/OvalSpinner";

const UnderConstruction = () => {
    // dispatch no longer needed; use centralized setters
    const [featureRequest, setFeatureRequest] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const errorSetter = useErrorSetter();
    const successSetter = useSuccessSetter();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post("/dashboard/feature-request", {
                featureRequest,
                email,
                name
            });
            if (response.status === 200) {
                successSetter("Feature request sent successfully!");
                setFeatureRequest("");
                setEmail("");
            } else {
                errorSetter("Failed.");
            }
        } catch (err) {
            errorSetter("Failed to send request.");
        }
        setLoading(false);
    };

  return (
    <div>
      <MenuBar />
        <div className="content">
            <UnderConstructionStyled>
                <div className="icon">
                    <LuConstruction />
                </div>
                <div className="BoxContainer">
                    <div className="info">
                        <h1>Whoops. <br/> This page is <br/> not available</h1>
                        <p>This link you clicked may be broken <br/> or under construction.</p>
                        <Button $pad="0.5rem 0.75rem" color="#fff" $bg="#5fbec5" title="Back to Home" link="/"/>
                    </div>
                    <div className="form">
                        <p>Want a specific Feature?<br/> join our exclusive waiting list.</p>
                        <h6 style={{ textAlign: "center" }}>Stand the chance to test new products for Free! <br/> tell us about it.</h6>
                        <div className="formContainer">
                            <form onSubmit={handleSubmit}>
                                <input type="text" placeholder="Enter your name" className="text" value={name} onChange={(e) => setName(e.target.value)} required />
                                <input type="email" placeholder="Enter your email" className="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                <textarea name="feature" id="" placeholder="what feature are you after?" cols="30" rows="5" value={featureRequest} onChange={(e) => setFeatureRequest(e.target.value)} required />
                                <Button secondary={true} width="100%" $bg="#5fbec5" disabled={loading} title={loading ? <OvalSpinner size={20} color="#fff" /> : "Send Feature Request"} />
                            </form>
                        </div>


                    </div>
                </div>


            </UnderConstructionStyled>
        </div>

    </div>
  );
};

export default UnderConstruction;

